// extracted by mini-css-extract-plugin
var _1 = "ProfileContactsWidgetButtonSelect-modulebutton__kLuLT";
var _2 = "ProfileContactsWidgetButtonSelect-moduledropdown__dsL_Y";
export { _1 as "button", _2 as "dropdown" }
